@for (toast of toastService.toasts; track toast) {
  <ngb-toast [class]="toast.classname" [autohide]="true"
    [delay]="toast.delay || 5000" [header]="toast.header" (hidden)="toastService.remove(toast)" (click)="toastService.remove(toast)">
    @if (isTemplate(toast)) {
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    } @else {
      <div class="d-flex align-items-center">
        <div [innerHTML]="toast.textOrTpl"></div><i class="fal fa-times ms-auto ps-2"></i>
      </div>
    }
  </ngb-toast>
}